var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", staticStyle: { padding: "10px 0 0 20px" } },
    [
      _c("span", { staticStyle: { color: "red", "line-height": "30px" } }, [
        _vm._v(
          "注意:下述为简单的国际化示例,请通过操作屏幕右上角的语言切换 观察效果"
        )
      ]),
      _c("div", { staticStyle: { "padding-bottom": "5px" } }, [
        _vm._v(_vm._s(_vm.$t("i18nDemo.btnDesc")))
      ]),
      _c(
        "div",
        [
          _c("el-button", { attrs: { type: "primary", size: "mini" } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.query")))
          ]),
          _c("el-button", { attrs: { type: "primary", size: "mini" } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.new")))
          ]),
          _c("el-button", { attrs: { type: "primary", size: "mini" } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.edit")))
          ]),
          _c("el-button", { attrs: { type: "danger", size: "mini" } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.delete")))
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.toTip }
            },
            [_vm._v(_vm._s(_vm.$t("i18nDemo.messageBtn")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }